import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  projects: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 1,
  },
  selectedProject: null,
  updating: false,
  deleting: false,
};

const projectSlice = createSlice({
  name: "companyProject",
  initialState,
  reducers: {
    // Get Projects
    getProjectsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getProjectsSuccess: (state, action) => {
      state.loading = false;
      state.projects = action.payload.projects || action.payload || [];
      if (action.payload.pagination) {
        state.pagination = action.payload.pagination;
      }
      state.error = null;
    },
    getProjectsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Project
    createProjectStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createProjectSuccess: (state, action) => {
      state.loading = false;
      state.projects.push(action.payload);
      state.error = null;
    },
    createProjectFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Project
    updateProjectStart: (state) => {
      state.updating = true;
      state.error = null;
    },
    updateProjectSuccess: (state, action) => {
      state.updating = false;
      const index = state.projects.findIndex(
        (project) => project.id === action.payload.id,
      );
      if (index !== -1) {
        state.projects[index] = action.payload;
      }
      state.error = null;
    },
    updateProjectFailure: (state, action) => {
      state.updating = false;
      state.error = action.payload;
    },

    // Delete Project
    deleteProjectStart: (state) => {
      state.deleting = true;
      state.error = null;
    },
    deleteProjectSuccess: (state, action) => {
      state.deleting = false;
      state.projects = state.projects.filter(
        (project) => project.id !== action.payload,
      );
      state.error = null;
    },
    deleteProjectFailure: (state, action) => {
      state.deleting = false;
      state.error = action.payload;
    },

    // Set Selected Project
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getProjectsStart,
  getProjectsSuccess,
  getProjectsFailure,
  createProjectStart,
  createProjectSuccess,
  createProjectFailure,
  updateProjectStart,
  updateProjectSuccess,
  updateProjectFailure,
  deleteProjectStart,
  deleteProjectSuccess,
  deleteProjectFailure,
  setSelectedProject,
  clearError,
} = projectSlice.actions;

export default projectSlice.reducer;
